<div class="grid gap-4 p-4 text-sm">
  <div>
    <div class="font-semibold">{{ dateLabel() }}{{ isDateSet() ? '' : ' (today)' }}</div>
    <div>Week {{ $ridCalendarService.currentWeekIndex() + 1 }}, day {{ $ridCalendarService.currentDayOfWeek() + 1 }}</div>
    <div>Day index {{ $ridCalendarService.currentDayIndex() }}</div>
  </div>

  <div class="flex gap-2">
    <button class="rounded-md border border-gray-400 px-2 py-1" (click)="$ridCalendarService.nextDay()">Next day</button>
    <button
      class="rounded-md border border-gray-400 px-2 py-1 disabled:opacity-50"
      [disabled]="!isDateSet()"
      (click)="$ridCalendarService.resetDate()"
    >
      Reset to today
    </button>
  </div>
</div>
